import React from 'react';
import MarkdownRenderer from './MarkdownRenderer';

function Post({ post, ...props }) {
  if (!post) return (
    <div className="max-w-4xl mx-auto px-4 py-12 text-center">
      <h2 className="text-2xl font-bold text-gray-700">Post not found.</h2>
      <p className="text-gray-500 mt-2">The post you are looking for does not exist.</p>
    </div>
  );

  // If the post has a component (MDX), render it
  if (post.component) {
    const Component = post.component;
    return (
      <div className="max-w-4xl mx-auto px-4 py-8">
        <article className="prose prose-lg max-w-none">
          <Component {...props} />
        </article>
      </div>
    );
  }

  // Otherwise, render the content as markdown
  return (
    <div className="max-w-4xl mx-auto px-4 py-8 sm:py-12">
      <article className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 md:p-10">
        <header className="mb-8 pb-8 border-b border-gray-100">
          <h1 className="text-3xl md:text-4xl font-extrabold text-gray-900 tracking-tight leading-tight mb-4">
            {post.title}
          </h1>
          {post.date && (
            <time className="text-sm font-medium text-blue-600">
              {post.date}
            </time>
          )}
        </header>
        <div className="prose prose-blue max-w-none">
          <MarkdownRenderer content={post.content} />
        </div>
      </article>
    </div>
  );
}

export default Post;